import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext";
import "./AdminAuth.css";

const PrivateAdminRoute = ({ component: Component, ...rest }) => {
  const { user, loading, logout } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return <div className="admin-auth-loading">A carregar...</div>;
        }

        if (!user) {
          return (
            <Redirect
              to={{
                pathname: "/admin/login",
                state: { from: props.location },
              }}
            />
          );
        }

        return (
          <>
            <header className="admin-bar">
              <div className="admin-bar-identity">
                <strong>J.Barquinha</strong>
                <span>{user.email}</span>
              </div>
              <button type="button" onClick={logout}>
                Sair
              </button>
            </header>
            <Component {...props} />
          </>
        );
      }}
    />
  );
};

export default PrivateAdminRoute;
